import React, { useMemo, useState } from "react";
import AssetLibrary from "./AssetLibrary/AssetLibrary";
import AssetUploader from "./AssetUploader/AssetUploader";
import UploadeWarningModal from "./AssetUploader/UploadWarningModal";
import { fileListObject, uploadedFileObject, IAssetUploaderState } from "./interfaces/uploaderInterfaces";
import { ReactComponent as UploadPlusIcon } from "../../assets/icons/AssetManager/add-gray-version-icon.svg";
import { ReactComponent as ExitIcon } from "../../assets/icons/Common/remove-tag-icon.svg";
import * as AssetManagerTypes from "./AssetManager.types";
import {
  usePageAssociation,
  useAssetManagerState,
  useAssetManagerDispatch,
  useAssetManager,
} from "./AssetManagerContext/AssetManagerProvider";
import InputPicker from "rsuite/InputPicker";
import "../Modals/CognitiveServices/inputPicker.css";
import { connect } from "react-redux";
import AssetMetadataEditor from "./AssetLibraryMetadataEditor/AssetMetadataEditor";
import IAsset from "../../models/IAsset";
import { AssetContext } from "../../routes/builderContexts";
import { useObjectsDispatch, useObjectsState, ObjectActionsType } from "../../contexts/ObjectsProvider";
import { useMovableElementsPlaneState } from "../../contexts/MovableElementsPlaneProvider";
let resolve: any;
function AssetManagerWrapper(props: any) {
  const [assetManagerMode, setAssetManagerMode] = useState<AssetManagerTypes.AssetManagerMode>("Library");
  const [uploadWarningShown, setUploadWarningShown] = useState<boolean>(false);
  const [uploadsProcessing, setUploadsProcessing] = useState<boolean>(false);
  // const [temporaryPagination, setTemporaryPagination] = useState(0)
  const assetContext = React.useContext(AssetContext);
  const assetManagerState = useAssetManager();
  const { viewportDOMElementWidth, viewportDOMElementHeight } = useMovableElementsPlaneState();

  const [saveAssets, setSaveAssets] = useState<boolean>(false);
  const [movingToLibraryFromUploader] = useState<boolean>(false);
  const [safeToCloseUploader, setSafeToCloseUploader] = useState<boolean>(false);
  const [saveAssetErrorMessage, setSaveAssetErrorMessage] = useState<string>("");
  const [closeCLick, setCloseClick] = useState(0);
  const pageAssociation = usePageAssociation(props.IGAAssetType);
  const state = useAssetManagerState();
  const dispatch = useAssetManagerDispatch();
  /***************************************************************UPLOADER STATE************************************************************************************************* */

  const [fileString, setFileString] = useState<string>("");
  const [filesUploaded, setFilesUploaded] = useState<number>(0);
  const [selectedId, setSelectedID] = useState<number>(-1);
  const [ataIds, setAtaIds] = useState<number[]>([]);
  const [newFiles, setNewFiles] = useState<fileListObject[]>([]); //needs to flag for loading
  const [uploadedAssets, setUploadedAssets] = useState<uploadedFileObject[]>([]);
  const [pageList, setPageList] = useState<number[]>([0]);

  const [versionName, setVersionName] = useState<string>("");
  const [canClickSave, setCanClickSave] = useState<boolean>(false);
  const [selectedLMS, setSelectedLMS] = useState<string>(props.lessonData?.lessonMetaData?.lmsLessonKey);
  const { objectList, selectedObjects } = useObjectsState();
  const objectsDispatch = useObjectsDispatch();

  const showLibrary = assetManagerMode === "Archives" || assetManagerMode === "Library";
  const uploaderState: IAssetUploaderState = {
    fileString,
    setFileString,
    filesUploaded,
    setFilesUploaded,
    selectedId,
    setSelectedID,
    ataIds,
    setAtaIds,
    newFiles,
    setNewFiles,
    uploadedAssets,
    setUploadedAssets,
    pageList,
    setPageList,
    versionName,
    setVersionName,
    canClickSave,
    setCanClickSave,
  };

  /******************************************************************************************************************************************************************************************* */

  async function handleCancel(safeToCancel?: boolean) {
    if (!safeToCancel) {
      const closeConfirm = await UploadeWarningModal.show({
        ...props,
        setUploadWarningShown: setUploadWarningShown,
      });
      if (closeConfirm) {
        props.setAssetManagerController({ isOpen: false, mode: "" });
      } else {
        setUploadWarningShown(false);
      }
    } else {
      props.setAssetManagerController((prev: any) => ({
        ...prev,
        isOpen: false,
      }));
    }
  }

  const addToPageClick = (e: any) => {
    if (props.assetManagerController.mode === "ImagesOnly" && props.IGAAssetType === 4) {
      props.getIGAImage(pageAssociation);
      handleCancel(true);
    } else if (props.assetManagerController.mode !== "References") {
      if (state.currentSelectedAsset.assetId !== -1) {
        pageAssociation();
        handleCancel(true);
      }
      if (props.assetManagerController.mode === "ImagesOnly") {
        const selectedObject = selectedObjects[0];
        const imagePath = assetManagerState.currentSelectedAsset.blobPath;
        const assetId = assetManagerState.currentSelectedAsset.assetId;
        const image = new Image();
        image.src = "/api/Asset/" + imagePath;
        image.onload = (e) => {
          if (!e.currentTarget) return;
          if (!viewportDOMElementHeight || !viewportDOMElementWidth) return;
          let imageWidth = e.currentTarget.naturalWidth;
          let imageHeight = e.currentTarget.naturalHeight;

          const imageAspectRatio = imageWidth / imageHeight;

          if (imageHeight > viewportDOMElementHeight) {
            imageHeight = viewportDOMElementHeight;
            imageWidth = imageHeight * imageAspectRatio;
          } else if (imageWidth > viewportDOMElementWidth) {
            imageWidth = viewportDOMElementWidth;
            imageHeight = imageWidth / imageAspectRatio;
          }
          const imagePercentWidth = (imageWidth / viewportDOMElementWidth) * 100;
          const imagePercentHeight = (imageHeight / viewportDOMElementHeight) * 100;

          objectsDispatch({
            type: ObjectActionsType.UPDATE_OBJECT,
            payload: {
              objectId: selectedObject.objectId,
              object: {
                width: imagePercentWidth,
                height: imagePercentHeight,
                natural: {
                  width: e.currentTarget.naturalWidth,
                  height: e.currentTarget.naturalHeight,
                },
              },
            },
          });
        };
        objectsDispatch({
          type: ObjectActionsType.UPDATE_IMAGE_ASSET,
          payload: { objectId: selectedObject.objectId, imagePath, assetVersionId: assetId },
        });
      }
      if (props.assetManagerController.mode === "VideosOnly") {
        const selectedObject = selectedObjects[0];
        const path = assetManagerState.currentSelectedAsset.blobPath;
        const assetId = assetManagerState.currentSelectedAsset.assetId;
        objectsDispatch({
          type: ObjectActionsType.UPDATE_VIDEO_ASSET,
          payload: { objectId: selectedObject.objectId, blobUrl: path, assetVersionId: assetId },
        });
      }
      if (props.assetManagerController.mode === "SCORM") {
        const selectedObject = selectedObjects[0];
        const path = assetManagerState.currentSelectedAsset.blobPath;
        const assetId = assetManagerState.currentSelectedAsset.assetId;
        objectsDispatch({
          type: ObjectActionsType.UPDATE_SCORM_ASSET,
          payload: { objectId: selectedObject.objectId, blobUrl: path, assetVersionId: assetId },
        });
      }
    } else {
      if (state.currentSelectedAsset.assetId !== -1) {
        resolve(state.currentSelectedAsset);
        props.setAssetManagerController({ isOpen: false, mode: "" });
      }
    }
  };

  const saveAssetClick = (e: any) => {
    setSaveAssets(true);
  };
  const setAssets = (assets: IAsset[]) => {
    dispatch({
      type: "SET_RETRIEVED_ASSETS",
      payload: assets,
    });
  };
  const moveToLibrary = async (e: any) => {
    if (assetManagerMode === "Uploader") {
      setAssetManagerMode("Library");
      setCloseClick(0);
    } else {
      setAssetManagerMode("Library");
      e.stopPropagation();
    }
  };

  function handleLMSChange(mySelectedLMS: string) {
    setSelectedLMS(mySelectedLMS);
  }
  const allowLibraryItem = props.isCpatUser && props.lmsKey === selectedLMS; // don't allow Share checkbox if not CPaT, or uploading to different LMS than current logged in

  const metadataEditor = useMemo(() => {
    return (
      <AssetMetadataEditor
        selectedAsset={state.currentSelectedAsset}
        assetsAreLoading={state.assetsAreLoading}
        isSameLMS={props.lmsKey === props.lessonData?.lessonMetaData?.lmsLessonKey}
        isCpatUser={props.isCpatUser}
        allowLibraryItem={allowLibraryItem}
        setAssets={setAssets}
        currentAssets={state.retrievedData}
        featuresToRender={props.featuresToRender}
      />
    );
  }, [state.currentSelectedAsset, state.assetsAreLoading]);

    const selectedAssetSizeMB =
        state.currentSelectedAsset?.sizeInBytes != null
            ? (state.currentSelectedAsset.sizeInBytes / (1024 * 1024))
            : null;
    const isLargeAsset = selectedAssetSizeMB != null && selectedAssetSizeMB > 200;

  return (
    <div
      className="assetManager-backdrop"
      onPointerDown={() => {
        newFiles.length > 0 ? handleCancel(false) : handleCancel(true);
      }}
      data-backdrop="backdrop"
    >
      <div
        className="assetManager-content-modal"
        onClick={(e) => {
          e.stopPropagation();
        }}
        onPointerDown={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="assetManager-title">
          <p>Asset Library Manager</p>
          <div
            onClick={() => {
              newFiles.length > 0 ? handleCancel(false) : handleCancel(true);
            }}
          >
            <ExitIcon />
          </div>
        </div>
        <div
          className="assetManager-modal-body"
          style={{
            gridTemplateColumns: showLibrary ? "5fr 2fr" : "1fr",
          }}
        >
          <div className="assetManager-modal-body-left">
            <p className="assetManager-infoText">Select asset from the library or add a new one</p>

            <div className="assetManager-library-upload-choose">
              <div className="upload-choose-buttons-container">
                <div
                  className={`assetManager-library-button${
                    assetManagerMode === "Library" ? " manager-selected-mode" : ""
                  }`}
                  onClick={moveToLibrary}
                >
                  <p>Library</p>
                </div>
                {props.featuresToRender.assetArchiving && (
                  <div
                    className={`assetManager-library-button${
                      assetManagerMode === "Archives" ? " manager-selected-mode" : ""
                    }`}
                    onClick={() => setAssetManagerMode("Archives")}
                  >
                    <p>Archives</p>
                  </div>
                )}
                <div
                  className={`assetManager-upload-button${
                    assetManagerMode === "Uploader" ? " manager-selected-mode" : ""
                  }`}
                  onClick={(e) => {
                    setAssetManagerMode("Uploader");
                    e.stopPropagation();
                  }}
                >
                  <p>
                    {" "}
                    <UploadPlusIcon /> Upload New
                  </p>
                </div>
              </div>
              {props.isCpatUser && assetManagerMode === "Uploader" && (
                <div className={"  cpat-user-button"}>
                  <span>Select LMS: </span>
                  <InputPicker
                    data={props.lessonData.lmss}
                    appearance="default"
                    placeholder="Select an LMS"
                    value={selectedLMS}
                    valueKey={"lmsKey"}
                    labelKey={"name"}
                    onChange={(e) => {
                      handleLMSChange(e as string);
                    }}
                    size={"sm"}
                    cleanable={false}
                    className={"language-dropdown"} // TODO
                    menuMaxHeight={550}
                  />
                </div>
              )}
            </div>

            {showLibrary && (
              <AssetLibrary
                allAvailableAircraft={props.allAvailableAircraft}
                mode={props.assetManagerController.mode}
                lessonPages={props.lessonPages}
                lessonAssetList={props.lessonAssetList}
                lessonVersionId={props.lessonVersionId}
                currentTab={assetManagerMode}
                excludeArchivedItems={assetManagerMode === "Library" && !state?.assetLibraryFilters[0]?.currentLesson}
              />
            )}

            {assetManagerMode === "Uploader" && (
              <AssetUploader
                saveAssets={saveAssets}
                movingToLibraryFromUploader={movingToLibraryFromUploader}
                setSaveAssets={setSaveAssets}
                tailoredForLms={props.lessonMetaData.customTailoredForLmss}
                isCpatUser={props.isCpatUser}
                lmsKey={props.lmsKey}
                lmsKeyForAssetOwner={props.isCpatUser ? selectedLMS : null}
                uploadWarningShown={uploadWarningShown}
                uploadsProcessing={uploadsProcessing}
                setUploadsProcessing={setUploadsProcessing}
                handleCancel={handleCancel}
                safeToClose={safeToCloseUploader}
                setSafeToClose={setSafeToCloseUploader}
                setSaveAssetErrorMessage={setSaveAssetErrorMessage}
                saveAssetErrorMessage={saveAssetErrorMessage}
                closeClick={closeCLick}
                setCloseClick={setCloseClick}
                uploaderState={uploaderState}
                allowLibraryItem={allowLibraryItem}
              />
            )}

            {uploadWarningShown ? (
              <UploadeWarningModal errorMessage={saveAssetErrorMessage} setUploadWarningShown={setUploadWarningShown} />
            ) : (
              <></>
            )}

            <div className="assetManager-buttons-container">
              {assetManagerMode === "Library" && isLargeAsset && (
                <div className="assetManager-size-warning">
                  <p>
                    The selected asset is{" "}
                    <span className="assetManager-size-warning-value">{selectedAssetSizeMB.toFixed(2)} MB </span> . For better
                    lesson performance, we recommend using smaller assets when possible. Would you like to continue
                    using this asset?
                  </p>
                </div>
              )}
              <button
                onClick={() => {
                  newFiles.length > 0 ? handleCancel(false) : handleCancel(true);
                }}
              >
                {assetManagerMode !== "Uploader" ? "Close" : "Cancel"}
              </button>
              {assetManagerMode !== "Uploader" ? (
                props.assetManagerController.mode !== "Standalone" &&
                !state.assetsAreLoading && (
                  <button
                    /* archived assets should not be added to the page */
                    className={state.currentSelectedAsset.isArchived ? "disabled" : ""}
                    onClick={(e) => {
                      if (state.currentSelectedAsset.isArchived) return;
                      addToPageClick(e);
                    }}
                  >
                    <p>{props.assetManagerController.mode === "References" ? "Add as Reference" : "Add To Page"}</p>
                  </button>
                )
              ) : (
                <button
                  onClick={
                    assetManagerMode !== "Uploader"
                      ? () => {
                          handleCancel(true);
                        }
                      : canClickSave
                      ? saveAssetClick
                      : undefined
                  }
                  style={{
                    opacity: canClickSave ? 1 : 0.5,
                    pointerEvents: canClickSave ? "all" : "none",
                  }}
                >
                  Save
                </button>
              )}
            </div>
          </div>

          {showLibrary && metadataEditor}
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state: any) => {
  return {
    lmsKey: state.authorizedState.lmsKey,
    isCpatUser: state.authorizedState.isCpatUser,
  };
};

AssetManagerWrapper.show = (open: any, mode: any) => {
  open({ isOpen: true, mode: mode });
  return new Promise((res) => {
    resolve = res;
  });
};

export default connect(mapStateToProps, {})(AssetManagerWrapper);
